import React, { useEffect, useRef, useState } from 'react';
import SectionHeader from '../ui/SectionHeader';
import { PROCESS_STEPS } from '../../data/site';

export default function Process() {
  const ref = useRef(null);
  const [active, setActive] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            // Cascade phase activation. Each step lights up 450ms apart so
            // the rail visibly fills as the section enters view.
            PROCESS_STEPS.forEach((_, i) => {
              setTimeout(() => setActive(i + 1), 400 * (i + 1));
            });
            io.disconnect();
          }
        });
      },
      { threshold: 0.25 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const fillPct = (active / PROCESS_STEPS.length) * 100;

  return (
    <section className="section" id="process" ref={ref}>
      <div className="container">
        <SectionHeader
          eyebrow="Process / 03"
          title="Discover. Design. Build. Scale."
          lede="Four phases, weekly cadence, transparent pricing. Most engagements run 8–14 weeks from kickoff to first ship — then ongoing as you grow."
        />

        <div className="process-rail">
          <div className="process-line">
            <div className="fill" style={{ '--p': fillPct + '%' }} />
          </div>
          <div className="process-steps">
            {PROCESS_STEPS.map((s, i) => (
              <div key={s.num} className={'process-step' + (i < active ? ' active' : '')}>
                <div className="num">PHASE · {s.num}</div>
                <h3>{s.title}</h3>
                <p>{s.body}</p>
                <ul>
                  {s.list.map((x) => <li key={x}>· {x}</li>)}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
